import { Routes, Route } from 'react-router-dom'
import { DirectoryHub } from './DirectoryHub'
import { DirectoryCountry } from './DirectoryCountry'
import { DirectoryCounty } from './DirectoryCounty'
import { DirectoryTown } from './DirectoryTown'
import { DirectoryPostcode } from './DirectoryPostcode'
import { DirectoryPlumber } from './DirectoryPlumber'
import { DirectoryNeighbourhood } from './DirectoryNeighbourhood'
import { DirectoryAreas } from './DirectoryAreas'
import { DirectoryPlumberFinder } from './DirectoryPlumberFinder'

/**
 * Shared sub-routes for /plumbers/*, /emergency-plumbers/*, /gas-safe-plumbers/* and /water-safe-plumbers/*.
 * useDirectoryMode() detects which mode is active from the URL prefix.
 *
 * Hierarchy: Country → County → Town → Postcode → Plumber
 * Neighbourhood: Country → County → area → Neighbourhood (e.g. /england/greater-london/area/putney)
 */
export function DirectoryRoutes() {
  return (
    <Routes>
      <Route index element={<DirectoryHub />} />
      <Route path="find/:directorySlug" element={<DirectoryPlumberFinder />} />
      <Route path=":countrySlug" element={<DirectoryCountry />} />
      <Route path=":countrySlug/:countySlug" element={<DirectoryCounty />} />
      <Route path=":countrySlug/:countySlug/areas" element={<DirectoryAreas />} />
      <Route path=":countrySlug/:countySlug/areas/:neighbourhoodSlug" element={<DirectoryNeighbourhood />} />
      <Route path=":countrySlug/:countySlug/:townSlug" element={<DirectoryTown />} />
      <Route path=":countrySlug/:countySlug/:townSlug/:postcodeSlug" element={<DirectoryPostcode />} />
      <Route path=":countrySlug/:countySlug/:townSlug/:postcodeSlug/:directorySlug" element={<DirectoryPlumber />} />
    </Routes>
  )
}
